// extracted by mini-css-extract-plugin
export default {"container":"ThemeInfo_container__WJTyM","info":"ThemeInfo_info__Qy98Y"};